export default __webpack_public_path__ + "media/images/bird-ui-preview-9e553cbd0bd4d927e3911662e8cd64ce.jpg";